/* Shamelessly stolen from https://github.com/Bynder/bynder-platform/blob/master/bynder-frontend/packages/paramount/src/common/components/FileSelector.tsx */

import React from 'react';
import styled from 'styled-components';

const HiddenInput = styled.input`
	display: none !important;
`;

interface Props {
	children: React.ReactChild;
	onFilesSelected: (files: File[]) => void;
	contentTypes: string[];
}

export default function FileSelector({ children, onFilesSelected, contentTypes }: Props) {
	let uploadInput: HTMLElement | undefined;

	const onClick = () => uploadInput?.click();

	const handleFilesSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.stopPropagation();
		event.preventDefault();

		if (event.target.files) {
			onFilesSelected(Array.from(event.target.files));
		}
	};

	const getAcceptedContentTypes = () => (contentTypes ? contentTypes.join(',') : '');

	return (
		<>
			{/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
			<div onMouseDown={onClick}>{children}</div>
			<HiddenInput
				data-testid="fileUploadInput"
				type="file"
				accept={getAcceptedContentTypes()}
				ref={(element: HTMLInputElement) => {
					uploadInput = element;
				}}
				onChange={handleFilesSelected}
			/>
		</>
	);
}
